<template>
  <BaseWrapper :loading="loading">
    <div class="space-y-4">
      <ShipmentOrderDetailCard label="Susulan Promo" type="reimbursement" :order="order" />
      <CreateShipmentForm
        v-if="stockMovement.data.id"
        :order="order"
        :order-id="$route.params.id"
        :loading="loadingOrderDetails"
        :stock-movement-id="stockMovement.data.id"
        :packed="stockMovement.data.attributes.is_packed"
        type="free_reimbursement"
        batch-mode="scan"
        @update-loading="(val) => (loadingOrderDetails = val)"
        @submitted="$router.push(indexPath)"
      >
        <template #action>
          <base-button color="white" :to="indexPath">
            <Icon icon="heroicons:arrow-uturn-left" class="h-4 w-4" />
            Kembali
          </base-button>
        </template>
      </CreateShipmentForm>
    </div>
  </BaseWrapper>
</template>

<script>
import CreateShipmentForm from '../../../../../components/shipment/create-shipment-form.vue';
import ShipmentOrderDetailCard from '../../../../../components/shipment/shipment-order-detail-card.vue';
import { requestMixin } from '../../../../../mixins/request/request.js';

export default {
  components: {
    ShipmentOrderDetailCard,
    CreateShipmentForm
  },
  mixins: [requestMixin],
  data() {
    return {
      indexPath: {
        name: 'gudang.susulan.promo'
      },
      loadingOrder: true,
      loadingStockMovement: true,
      loadingOrderDetails: true,
      order: {
        data: {
          attributes: {},
          relationships: {
            'destination-office': {
              data: null,
            },
            'origin-office': {
              data: null,
            },
            village: {
              data: null,
            },
            district: {
              data: null,
            },
            city: {
              data: null,
            },
            province: {
              data: null,
            },
          },
        },
        included: [],
      },
      stockMovement: {
        data: {
          attributes: {},
        }
      }
    }
  },
  computed: {
    loading() {
      return this.loadingOrder || this.loadingStockMovement || this.loadingOrderDetails
    }
  },
  methods: {
    async loadOrder() {
      this.loadingOrder = true;

      const [res, err] = await this.request(
        `/api/v1/orders/${this.$route.params.id}`,
        {
          params: {
            include:
              'destination-office,village,district,city,province,origin-warehouse,destination-warehouse,origin-office',
            'fields[orders]':
              'is_transfer_promo,is_transfer_promo_regular,warehouse_status,origin_code,destination_code,orderedAt,createdAt,destination-office,order_shipment,shipment_address,village,district,city,province,origin-warehouse,destination-warehouse,origin-office,receipt_name,receipt_phone',
            'fields[offices]': 'code,name,full_address,phone,cellphone',
            'fields[villages]': 'name',
            'fields[districts]': 'name',
            'fields[cities]': 'name',
            'fields[provinces]': 'name',
            'fields[warehouses]': 'code',
          },
        }
      );

      if (!err) {
        this.order = res;
      }

      this.loadingOrder = false;
    },
    async loadStockMovement() {
      this.loadingStockMovement = true;

      const [res, err] = await this.request(
        `/api/v1/orders/${this.$route.params.id}/-actions/current-stock-movement`,
        {
          params: {
            type: 'free_reimbursement'
          }
        }
      );

      if (!err) {
        this.stockMovement = res;
      }

      this.loadingStockMovement = false;
    }
  },
  created() {
    this.loadOrder()
    this.loadStockMovement()
  }
}
</script>